@if (loading) {
  <mat-spinner diameter="20" class="mt-3" />
} @else {
  @if (form) {
    <form [formGroup]="form.formGroup">
      <div class="row align-items-center">
        <div class="col-lg-9">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput placeholder="Ex. Banana" [formControl]="form.controls.name" />
          </mat-form-field>
        </div>

        <div class="col-lg-3 text-end">
          <mat-form-field>
            <mat-label>Product Group</mat-label>
            <mat-select [formControl]="form.controls.productGroup">
              <mat-option [value]="null">-</mat-option>

              @for (option of form.contextData.productGroups; track $index) {
                <mat-option [value]="option.id">{{ option.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
  }

  <div class="row">
    <mat-chip-listbox class="mb-3">
      <mat-chip-option selected (selectionChange)="changeSelection(null)">
        All ({{ overview.numberOfProducts }})
      </mat-chip-option>

      <mat-chip-option (selectionChange)="changeSelection('Low Stock')" color="accent">
        Running Low ({{ overview.numberOfOutOfStockProducts }})
      </mat-chip-option>

      <mat-chip-option class="orange" (selectionChange)="changeSelection('Expired')">
        Expired ({{ overview.numberOfExpiredProducts }})
      </mat-chip-option>

      <mat-chip-option class="yellow" (selectionChange)="changeSelection('Expiring Soon')">
        Expiring ({{ overview.numberOfExpiringProducts }})
      </mat-chip-option>

      <mat-chip-option (selectionChange)="changeSelection('Opened')">
        Opened ({{ overview.numberOfOpenedProducts }})
      </mat-chip-option>
    </mat-chip-listbox>
  </div>

  <app-grocy-stock-table [dataSource]="dataSource" />
}
